import { Component, Input, AfterContentInit } from '@angular/core';
import * as Tooltip from 'tooltip-js';
import { TranslateService } from '@ngx-translate/core';

interface TooltipObject {
  title: string
  description: string
}

@Component({
  selector: 'app-tooltip',
  templateUrl: './tooltip.component.html',
  styleUrls: ['./tooltip.component.less']
})
export class TooltipComponent implements AfterContentInit  {
  // VS: Input position object stands for circle badge position
  // you can use top, right, bottom and left, they're not mandatory
  @Input('position') position: {top?: string, right?: string, bottom?: string, left?: string};
  public tooltip: TooltipObject;
  public tooltipContent: Tooltip;
  public translation = {};
  public isOpened: boolean = false;
  public key: string = '';
  constructor (
    public translateService: TranslateService) {
    this.getTranslation();
   }

   ngAfterContentInit() {
    this.tooltipContent = new Tooltip({
      el: document.body.querySelector('.horse-content'),
      activeClass: 'horse-content-active',
      triggerClass: 'horse-content-toggle-btn'
    });
  }

  showTooltip(key, localClass) {
    if (!this.isOpened && key) {
      this.key = key;
      this.renderTooltip(key, localClass);
      this.isOpened = true;
    } else {
      return;
    }
  }

  hideTooltip() {
    this.key = '';
    this.tooltip = {
      title: '',
      description: ''
    }
    this.tooltipContent.hide();
    setTimeout(() => this.isOpened = false, 500)
  }

  renderTooltip(key: string, localClass: string) {
    switch(key) {
      case 'add-horse': {
        this.tooltipContent = new Tooltip({
          el: document.body.querySelector(`${localClass} .horse-content`),
          activeClass: 'horse-content-active',
          triggerClass: 'horse-content-toggle-btn'
        });
        this.tooltip = {
          title: this.translation['add_horse_title'],
          description: this.translation['add_horse_description']
        };
        return this.tooltipContent.show();
      }
      case 'add-treatment':{
        this.tooltipContent = new Tooltip({
          el: document.body.querySelector(`${localClass} .horse-content`),
          activeClass: 'horse-content-active',
          triggerClass: 'horse-content-toggle-btn'
        });
        this.tooltip = {
          title: this.translation['add_treatment_title'],
          description: this.translation['add_treatment_description']
        };
        return this.tooltipContent.show();
      }
      case 'invite-user':
        this.tooltipContent = new Tooltip({
          el: document.body.querySelector(`${localClass} .horse-content`),
          activeClass: 'horse-content-active',
          triggerClass: 'horse-content-toggle-btn'
        });
        this.tooltip = {
          title: this.translation['invite_user_title'],
          description: this.translation['invite_user_description']
        };
        return this.tooltipContent.show();
      case 'add-vaccination':
        this.tooltipContent = new Tooltip({
          el: document.body.querySelector(`${localClass} .horse-content`),
          activeClass: 'horse-content-active',
          triggerClass: 'horse-content-toggle-btn'
        });
        this.tooltip = {
          title: this.translation['add_vacc_title'],
          description: this.translation['add_vacc_description']
        };
        return this.tooltipContent.show();
      case 'add-report':
        this.tooltipContent = new Tooltip({
          el: document.body.querySelector(`${localClass} .horse-content`),
          activeClass: 'horse-content-active',
          triggerClass: 'horse-content-toggle-btn'
        });
        this.tooltip = {
          title: this.translation['add_report_title'],
          description: this.translation['add_report_description']
        };
        return this.tooltipContent.show();
      default: 
        return this.hideTooltip();
    }
  }

  renderTooltipPosition() {
    return this.position;
  }

  renderTooltipStyle() {
    // VS: This renders triangle position regards on given key
    switch(this.key) {
      case 'add-horse': {
        return {
          top: '95px',
          left: '-8px'
        }
      }
      case 'add-treatment': {
        return {
          top: '195px',
          left: '-8px'
        }
      }
      case 'invite-user': {
        return {
          top: '20px',
          left: '-8px'
        }
      }
      case 'add-vaccination': {
        return {
          top: '20px',
          left: '-8px'
        }
      }
      case 'add-report': {
        return {
          top: '20px',
          left: '-8px'
        }
      }
    }
  }

  getTranslation() {
    this.translateService.get('TOOLTIPS.add_horse_title').subscribe((word: string) => {
      this.translation['add_horse_title'] = word;
    });
    this.translateService.get('TOOLTIPS.add_horse_description').subscribe((word: string) => {
      this.translation['add_horse_description'] = word;
    });
    this.translateService.get('TOOLTIPS.add_treatment_title').subscribe((word: string) => {
      this.translation['add_treatment_title'] = word;
    });
    this.translateService.get('TOOLTIPS.add_treatment_description').subscribe((word: string) => {
      this.translation['add_treatment_description'] = word;
    });
    this.translateService.get('TOOLTIPS.invite_user_title').subscribe((word: string) => {
      this.translation['invite_user_title'] = word;
    });
    this.translateService.get('TOOLTIPS.invite_user_description').subscribe((word: string) => {
      this.translation['invite_user_description'] = word;
    });
    this.translateService.get('TOOLTIPS.add_vacc_title').subscribe((word: string) => {
      this.translation['add_vacc_title'] = word;
    });
    this.translateService.get('TOOLTIPS.add_vacc_description').subscribe((word: string) => {
      this.translation['add_vacc_description'] = word;
    });
    this.translateService.get('TOOLTIPS.add_report_title').subscribe((word: string) => {
      this.translation['add_report_title'] = word;
    });
    this.translateService.get('TOOLTIPS.add_report_description').subscribe((word: string) => {
      this.translation['add_report_description'] = word;
    });
  }
}



// WEBPACK FOOTER //
// /home/vsts/work/1/s/emr-webapp/src/app/core/tooltip/tooltip.component.ts